import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { throwErr } from '@/api/throw_err'
import { Message } from 'element-ui';
import { GetRequest } from "@/utils/util";
import { nuofang_api } from '@/config/common';

let current_domain = document.domain

var baseURL = '/api/wz_api_php/api/'
if (process.env.DOCK_ENV) {
  baseURL = nuofang_api + '/api/wz_api_php/api/'
}

const req = axios.create({
  baseURL: baseURL
})

//请求拦截器
req.interceptors.request.use(config => {
	config.timeout = 60 * 1000 //请求响应时间
  //发起请求时，取消掉当前正在进行的相同请求
  // if (promiseArr[config.url]) {
  //     promiseArr[config.url]('操作取消')
  //     promiseArr[config.url] = cancel
  // } else {
  //     promiseArr[config.url] = cancel
  // }
  if (config.url == 'user/getUserInfo') {
    if (store.state.token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = store.state.token;
    }else{
      // router.replace({name: 'login'})
    }
  }
  
  return config
}, error => {
    return Promise.reject(error)
})

// 对接时使用：获取统一用户相关信息
const reqAuth = axios.create({
  baseURL: "/nuofang-wz-api/uuc/gw/novauc/"
});

//请求拦截器
reqAuth.interceptors.request.use(
  config => {
    config.timeout = 5 * 60 * 1000; //请求响应时间
    var token = sessionStorage.getItem("10015_yc_token")
    if (token) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      if (config.auth !== false) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
reqAuth.interceptors.response.use(
  // 请求成功
  res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
  // 请求失败
  error => {
    const {response} = error
    if (response) {
      return Promise.reject(response)
    }
  }
)

export {
  req,
  reqAuth
}


// WEBPACK FOOTER //
// ./src/api/api_request.js